import { WorkflowItem } from '../../store/interfaces';
import { currentWorkflowItemSlice } from '../reducers/currentWorkflowItemSlice';
import { getStore } from '../store';

export const currentWorkflowItemProvider = (): {
  updateCurrentWorkflowItem: (
    currentWorkflowItem: WorkflowItem,
  ) => { payload: WorkflowItem; type: 'currentWorkflowItem/setCurrentWorkflowItem' };
} => {
  const { dispatch } = getStore();
  const { setCurrentWorkflowItem } = currentWorkflowItemSlice.actions;
  return {
    updateCurrentWorkflowItem: (currentWorkflowItem: WorkflowItem) =>
      dispatch(setCurrentWorkflowItem(currentWorkflowItem)),
  };
};
